export default "https://d1e6s5z4lzmgxx.cloudfront.net/6e52c691-29e3-4541-bed6-a97355993ecd/images/fortisimo-icon.svg?cd52fbd6408a9f4f0b25374cad804a27";